export default __webpack_public_path__ + "static/media/download.5fe5f96b.svg";